import { createContext, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { FeatureFlags } from '../services';

export const FeatureFlagsContext = createContext<{
  featureFlags: FeatureFlags;
  featureFlagsLoadingStatus: LoadingStatuses;
}>(null!);

type FeatureFlagsProviderProps = {
  children?: ReactNode;
  featureFlags: FeatureFlags;
  featureFlagsLoadingStatus: LoadingStatuses;
};
const maxTryCount = 50;

export const FeatureFlagsProvider = ({
  children,
  featureFlags,
  featureFlagsLoadingStatus,
}: FeatureFlagsProviderProps) => {
  const [updateCount, setStateUpdateCount] = useState(0);
  const tryCount = useRef(0);

  useEffect(() => {
    const noop = () => {};

    if (!featureFlags) return noop();

    featureFlags.setStateUpdateHandler(() => {
      // in cause when user can't provide enough data for initialization GrowthBook prevent infinite loop
      if (tryCount.current >= maxTryCount) {
        return;
      }
      tryCount.current += 1;
      setStateUpdateCount((value) => value + 1);
    });

    return () => {
      featureFlags.setStateUpdateHandler(noop);
    };
  }, [featureFlags]);

  const providerValue = useMemo(() => {
    return { featureFlags, featureFlagsLoadingStatus };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureFlags, featureFlagsLoadingStatus, updateCount]);

  return <FeatureFlagsContext.Provider value={providerValue}>{children}</FeatureFlagsContext.Provider>;
};
